<template>
  <div class="text-center">
    <v-dialog
      v-model="dialog"
      content-class="crud-dialog"
      persistent
      max-width="400px"
    >
      <template #activator="{ on }">
        <div class="list-item">
          <v-btn
            class="list-item-btn"
            :ripple="false"
            block
            color="white"
            v-on="advisorCode ? {} : on"
            :disabled="!!advisorCode"
          >
            <div class="list-item-text">
              <span class="list-item-name">{{ advisorCode }}</span>
            </div>
          </v-btn>
        </div>
      </template>

      <v-card class="crud-card">
        <v-card-title class="crud-card-title">
          <v-row no-gutters>
            <v-col cols="11">
              <h2 class="text-h5">Add advisor code</h2>
            </v-col>
            <v-col cols="1">
              <v-icon
                class="modal-close"
                color="black"
                @click.stop="closeDialog"
                >{{ icons.mdiClose }}</v-icon
              >
            </v-col>
          </v-row>
        </v-card-title>

        <v-divider />

        <v-card-text class="crud-card-text">
          <ValidationObserver ref="observer">
            <ValidationProvider
              id="advisor-code"
              v-slot="{ errors }"
              name="advisor-code"
              rules="required|adviserCode"
            >
              <v-text-field
                v-model.trim="advisorCodeInput"
                label="Advisor Code"
                :error-messages="errors"
              />
            </ValidationProvider>
          </ValidationObserver>
        </v-card-text>

        <v-card-actions class="crud-card-actions">
          <v-btn
            rounded
            depressed
            :loading="buttonLoading"
            color="primary"
            class="ml-4 mb-1"
            @click="save()"
            ><span>Save</span
            ><v-icon small>{{ icons.mdiArrowRight }}</v-icon></v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <ErrorSnackbar v-model="showError" :error="errorMessage" />
    <SuccessSnackbar v-model="showSuccess" :message="successMessage" />
  </div>
</template>

<script>
  import ErrorSnackbar from '../common/ErrorSnackbar.vue';
  import SuccessSnackbar from '../common/SuccessSnackbar.vue';
  import { formHelperMixin } from '../../mixins/form-helper-mixin';
  import { UPDATE_USER_MUTATION } from '../../constants/graphql/users';
  import { TESTATOR_QUERY } from '../../constants/graphql/testators';

  export default {
    name: 'UpdatePhone',
    components: {
      ErrorSnackbar,
      SuccessSnackbar,
    },
    mixins: [formHelperMixin],
    props: {
      advisorCode: {
        required: false,
        type: String,
      },
    },
    data() {
      return {
        advisorCodeInput: null,
        dialog: false,
        errorMessage: null,
        showSuccess: false,
        successMessage: null,
      };
    },
    watch: {
      dialog(newValue) {
        if (newValue == true) {
          this.errorMessage = null;
          this.advisorCodeInput = this.advisorCode;
        }
      },
    },
    methods: {
      save() {
        this.$refs.observer.validate().then(valid => {
          if (valid) {
            this.buttonLoading = true;
            this.updateAdvisorCode();
          } else {
            const errors = this.$refs.observer.ctx.errors;
            document
              .getElementById(
                Object.keys(errors).find(field => errors[field].length)
              )
              .scrollIntoView({ block: 'center', behavior: 'smooth' });
          }
        });
      },
      updateAdvisorCode() {
        const userInputDetails = {
          advisorCode: this.advisorCodeInput,
        };
        const id = this.userId;

        this.$apollo
          .mutate({
            mutation: UPDATE_USER_MUTATION,
            variables: {
              id,
              userInputDetails,
            },
            update: (cache, { data: { updateUser } }) => {
              this.updateCacheAfterUpdateUser(cache, updateUser);
            },
          })
          .then(_response => {
            this.showSuccessMessage();
          })
          .catch(error => {
            if (error.message.includes('GraphQL error:')) {
              this.errorMessage = error.message
                .replace('GraphQL error:', '')
                .trim();
              this.displayErrorAndCloseDialog();
            } else {
              this.displayErrorAndCloseDialog();
              throw error;
            }
          });
      },
      updateCacheAfterUpdateUser(cache, updateUser) {
        const query = {
          query: TESTATOR_QUERY,
          variables: { id: this.testatorId },
        };
        const data = cache.readQuery(query);

        data.testator.user.advisorCode = this.advisorCodeInput;

        cache.writeQuery({ ...query, data });
      },
      showSuccessMessage() {
        this.successMessage = 'Your advisor code has been updated';
        this.showSuccess = true;
        this.closeDialog();
      },
      closeDialog() {
        this.dialog = false;
        this.buttonLoading = false;
        this.$refs.observer.reset();
      },
    },
  };
</script>
